const initialState = {
    templateFormIsOpen: false,
    editFromIsOpen: false
}

const plannersReducer = (state = initialState, action) => {
    // console.log(action, "HANDLE_ADD_TEMPLATE_EDIT_FORM_IS_OPEN")
    switch (action.type) {
        case 'HANDLE_ADD_TEMPLATE_FORM_IS_OPEN':
            return { ...state, templateFormIsOpen: action.value }
            break
        case "HANDLE_ADD_TEMPLATE_EDIT_FORM_IS_OPEN":
            return { ...state, editFromIsOpen: action.value }
            break
        default:
            return state
    }
}

export default plannersReducer